import { render, staticRenderFns } from "./table-project.vue?vue&type=template&id=2d669b7c&scoped=true&"
import script from "./table-project.vue?vue&type=script&lang=js&"
export * from "./table-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d669b7c",
  null
  
)

export default component.exports